<template>
    <footer class="footer">
        <p>成都市高新区科园二路一号201室 028-85192910 028-66052899 13880586898（范小林）18980535778(李)</p>
        <p>copyright © 2013 成都利马高科有限公司 川ICP备09000473号</p>
    </footer>
</template>

<script>
export default {

}
</script>

<style scoped>
.footer{
    height: 70px;
    text-align: center;
    margin-top:5px;
    border-top:1px solid #dae0e3;
    flex: 0;
}
.footer>p:nth-child(1){
    font-size: 20px;
    margin: 10px 0;
    color:#353535
}
.footer>p:nth-child(2){
    font-size: 12px;
     color:#9daab2
}
@media(max-width:9000px){
.footer>p:nth-child(1){
    font-size: 12px
}
}
</style>



// WEBPACK FOOTER //
// pageFooter.vue?772b130c